module.exports = __webpack_public_path__ + "static/shield2-4f9ef62d59d3e569b841ef37e0699e16.png";